import { useClientSide } from '~/hooks/common';

function useShowPriceDetailsImmediately() {
  if (!useClientSide()) return false;

  const params = new URL(window.location.href.toLowerCase()).searchParams;
  const fromCreditKarma =
    params.get('utm_source') === 'creditkarma' && params.has('sub_id');
  const isFinanceActivationUser =
    params.has('oneusetoken') &&
    (params.has('isfinsearch') || params.get('actmodal') === 'finance');

  return fromCreditKarma || isFinanceActivationUser;
}

export default useShowPriceDetailsImmediately;
